import React, {Component} from 'react'
import './Navigation.css'


export class Navigation extends Component {

    render(){
        return(
            <div className="navigation">
                
            </div>
        )
    }
}

